import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../../generic/icon/Icon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
import { BuildingItemContainer } from "../../player-base/buildings/upgrade/BuildingItemContainer";
export var OutskirtBuildingUpgradeNew = function (_a) {
    var building = _a.building, nextStage = _a.nextStage, currentStage = _a.currentStage, upgradeEffects = _a.upgradeEffects, children = _a.children;
    var buildingName = building.balancing.name;
    return (React.createElement("div", { className: "building-upgrade__new" },
        React.createElement(BuildingItemContainer, { className: "building-new__container", buildingName: buildingName, stage: nextStage }),
        React.createElement("div", { className: "building-upgrade__effects " + IdStyles.BuildingUpgradeEffectsWrapper }, upgradeEffects.map(function (_a) {
            var icon = _a.icon, bonusValue = _a.bonusValue;
            var upgradeBonus = (React.createElement(React.Fragment, null, bonusValue ? (React.createElement(NumberFormat, { format: TypeNumberFormat.Add, amount: bonusValue, className: IdStyles.TextBoldPrimary })) : (undefined)));
            return (React.createElement("div", { className: "building-upgrade__effects-item", key: icon },
                React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
                upgradeBonus));
        })),
        children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/outskirts/upgrade/OutskirtBuildingUpgradeNew.tsx
// module id = 2639
// module chunks = 3